export default __webpack_public_path__ + "locales/si/Common.json?hash=4f4795a3d3ef997663f8608097867c86";